
import React, { useState } from 'react';
import { motion, AnimatePresence, } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

const BLOG_DATA = [

  {
    id: 1,
    title: "Future of AI in 2026",
    excerpt: "AI is changing how we live and work every single day...",
    content: "Detailed Content: AI has evolved beyond simple automation. In 2026, we are seeing systems that can reason and create with human-like precision. This post explores the impact on global economies and personal productivity.",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&q=80&w=800",
    category: "Technology"
  },
  {
    id: 2,
    title: "Minimalist Web Design",
    excerpt: "Why less is more in the modern digital landscape...",
    content: "Detailed Content: Minimalist design isn't just about white space; it's about intentionality. By removing friction, users focus on what truly matters—the content.",
    image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&q=80&w=800",
    category: "Design"
  },
  {
    id: 3,
    title: "React Server Components",
    excerpt: "Understanding the shift in modern React development...",
    content: "Detailed Content: RSCs allow developers to build faster, more efficient applications by offloading work to the server. This reduces bundle sizes drastically.",
    image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?auto=format&fit=crop&q=80&w=800",
    category: "Coding"
  },
  {
    id: 4,
    title: "Digital Marketing",
    excerpt: "Turning Clicks Into Clients! Ready to scale your business? Let’s make it happen 🚀",
    content: "Welcome to Digital Canto, where we turn clicks into conversions and brands into market leaders. From PPC and SEO to Social Media and Email Marketing, we craft result-driven strategies that grow your business",
    image: "images/DigitalMarketing.jpg",
    category: "Digital Marketing"
  },
  {
    id: 5,
    title: "Performance Marketing",
    excerpt: "Boosted lead generation by 200% through paid ads 🚀",
    content: "Generating quality leads is the backbone of any successful business, and paid advertising plays a powerful role in achieving this. By using data-driven strategies, audience targeting, and optimized ad creatives, we helped a brand boost its lead generation by 200% in a short span of time. Our approach focused on selecting the right platforms, refining keywords, testing multiple ad copies, and continuously optimizing campaigns for better performance. As a result, the cost per lead reduced significantly while conversion rates increased. This growth proves that when paid ads are executed strategically, they don’t just bring traffic—they bring real, measurable business results.",
    image: "images/performanceMarketing.jpg",
    category: "Performance Marketing"
  },
  {
    id: 6,
    title: "PR & Brand Collabration Marketing",
    excerpt: "PR and brand collaboration marketing focus on building strong brand presence through strategic partnerships and media exposure.",
    content: "PR and brand collaboration marketing help businesses build trust, visibility, and long-term credibility. By partnering with the right influencers, creators, and brands, companies can reach new audiences organically and authentically. Strategic PR campaigns combined with meaningful collaborations strengthen brand image, improve engagement, and create lasting impressions in the market. When executed correctly, these collaborations go beyond promotion—they build relationships, boost brand authority, and drive consistent growth while positioning the brand as reliable and relevant in a competitive digital landscape.",
    image: "images/Collaboration-Marketing.jpg",
    category: "PR & Brand Collabration Marketing"
  },
  {
    id: 7,
    title: "Custom Coded Software",
    excerpt: "Custom coded software delivers tailored, scalable solutions built specifically to match your business processes, performance needs, and long-term growth goals.",
    content: "Custom coded software is designed to fit your business needs, not the other way around. Unlike ready-made tools, it offers complete flexibility, scalability, and control over features and performance. Every solution is built from the ground up to match your workflow, goals, and future growth. This approach improves efficiency, enhances security, and ensures seamless integration with existing systems—helping businesses operate smarter, faster, and more effectively.",
    image: "images/Custom-coded.webp",
    category: "Custom Coded Software"
  },
  {
    id: 8,
    title: "SEO",
    excerpt: "SEO services improve website visibility, increase organic traffic, and help your business rank higher on search engines with long-term results.",
    content: "Search Engine Optimization focuses on improving your website’s visibility across search engines through strategic optimization techniques. It involves keyword research, technical improvements, content optimization, and quality link building to attract the right audience organically. A well-planned SEO strategy enhances website performance, increases credibility, and drives consistent traffic over time. By aligning search intent with valuable content, SEO helps businesses achieve sustainable growth and stronger online presence in competitive markets.",
    image: "images/seo.jpg",
    category: "SEO"
  }
];

const OurTeams = () => {
  const [selectedPost, setSelectedPost] = useState(null);

  return (
    <div className="min-h-screen bg-[#fafafa] py-20 px-6 font-sans">
      <div className="max-w-[1600px] mx-auto">
        <div className="flex flex-col mb-24 border-b border-black pb-10">
          <motion.h1
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="text-[4vw] leading-[0.8] font-black uppercase tracking-tighter text-secondary"
          >
            Blogs <span className="italic font-light text-primary"><br />Insights</span>
          </motion.h1>
          <div className="flex justify-between items-center mt-6">
            <p className="text-sm font-bold tracking-widest uppercase text-gray-400">Edition Latest</p>
            <p className="max-w-xs text-right text-xs font-medium uppercase leading-relaxed text-gray-700 ">
              Transform your business with Digital Canto's expert digital marketing strategies. From PPC and SEO to social media mastery and email campaigns, we turn clicks into loyal customers and brands into market leaders. Scale smarter, grow faster!
            </p>
          </div>
        </div>

        {/* Mobile: 1 Slide Auto-scroll */}
        <div className="lg:hidden">
          <Swiper
            modules={[Autoplay, Pagination]}
            slidesPerView={1}
            autoplay={{ delay: 3500 }}
            pagination={{ clickable: true }}
            className="pb-16"
          >
            {BLOG_DATA.map(post => (
              <SwiperSlide key={post.id}>
                <ArtCard post={post} onClick={() => setSelectedPost(post)} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* Desktop: Precision 4-Column Grid */}
        <div className="hidden lg:grid grid-cols-4 gap-x-8 gap-y-16">
          {BLOG_DATA.map((post, i) => (
            <ArtCard key={post.id} post={post} onClick={() => setSelectedPost(post)} />
          ))}
        </div>
      </div>


      <AnimatePresence>
        {selectedPost && (
          <ImmersiveModal post={selectedPost} onClose={() => setSelectedPost(null)} />
        )}
      </AnimatePresence>
    </div>
  );
};

const ArtCard = ({ post, onClick }) => (
  <motion.div
    onClick={onClick}
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    whileHover={{ y: -15 }}
    className="group cursor-pointer relative"
  >
    <div className="overflow-hidden bg-gray-100 mb-6 aspect-[3/4]">
      <motion.img
        whileHover={{ scale: 1.1, rotate: 2 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        src={post.image}
        className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700"
      />
    </div>
    <div className="flex flex-col space-y-2">
      <span className="text-[10px] font-black tracking-[0.3em] uppercase text-black">{post.category}</span>
      <h3 className="text-xl font-bold tracking-tight text-secondary group-hover:underline decoration-2 underline-offset-8">
        {post.title}
      </h3>
    </div>
  </motion.div>
);

const ImmersiveModal = ({ post, onClose }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    className="fixed inset-0 z-[100] bg-black/20 backdrop-blur-sm flex justify-end"
    onClick={onClose}
  >
    <motion.div
      initial={{ x: "100%" }}
      animate={{ x: 0 }}
      exit={{ x: "100%" }}
      transition={{ type: "spring", damping: 30, stiffness: 200 }}
      onClick={(e) => e.stopPropagation()}
      className="w-full md:w-[70vw] bg-white h-full shadow-[-20px_0_80px_rgba(0,0,0,0.1)] overflow-y-auto"
    >

      <div className="sticky top-0 z-20 bg-white/80 backdrop-blur-md px-10 py-6 flex justify-between items-center border-b border-gray-100">
        <span className="font-mono text-xs tracking-widest uppercase text-gray-500">{post.category}</span>
        <button
          onClick={onClose}
          className="group flex items-center space-x-2 text-black"
        >
          <span className="text-xs font-bold uppercase tracking-widest group-hover:mr-2 transition-all">Close</span>
          <span className="text-3xl font-thin">→</span>
        </button>
      </div>

      <div className="p-10 md:p-24">

        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="w-full aspect-video overflow-hidden rounded-sm mb-20 shadow-2xl"
        >
          <img src={post.image} className="w-full h-full object-cover" alt="" />
        </motion.div>
        <div className="max-w-3xl">
          <motion.h2
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="text-5xl md:text-5xl text-secondary tracking-tighter mb-12 font-semibold"
          >
            {post.title}
          </motion.h2>

          <motion.div
            initial={{ y: 40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="prose prose-2xl"
          >
            <p className="text-gray-400 font-medium mb-10 leading-relaxed italic border-l-8 border-indigo-600 pl-8">
              {post.excerpt}
            </p>
            <div className="text-gray-800 leading-relaxed text-xl space-y-6">
              {post.content}
            </div>
          </motion.div>
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="mt-20 w-full md:w-auto bg-primary text-white px-16 py-6 rounded-full font-bold uppercase tracking-widest hover:bg-secondary transition-colors shadow-2xl"
          >
            Project Exploration →
          </motion.button>
        </div>
      </div>
    </motion.div>
  </motion.div>
);

export default OurTeams;